import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import CopyToClipboard from "react-copy-to-clipboard";
import ReactElasticCarousel from "react-elastic-carousel";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Get } from "../../Axios/AxiosFunctions";
import { BaseURL, imageUrl } from "../../config/apiUrl";
import { loaderGif } from "../../constant/imagePath";
import { addItemToCart, removeItemFromCart } from "../../redux/cart/cart";
import { saveLocation } from "../../redux/common/commonSlice";
import Button from "../../stories/Button/Button";
import CarouselPagination from "../../stories/CarouselPagination";
import Footer from "../../stories/Footer";
import Header from "../../stories/Header";
import ShowMoreShowLessText from "../../stories/ShowMoreShowLess/ShowMoreShowLessText";
import classes from "./CardDetailPage.module.css";
const CardDetailPage = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  useEffect(() => {
    dispatch(saveLocation(location));
  }, []);

  const accessToken = useSelector((state) => state?.authReducer?.access_token);
  const [cardData, setCardData] = useState(null);
  const cart = useSelector((state) => state?.cartReducer?.cart);
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(true);

  // get data
  const getData = async () => {
    setIsLoading(true);
    const response = await Get(BaseURL(`cards/detail/${id}`));
    setIsLoading(false);
    if (response != undefined) {
      setCardData(response?.data?.data);
    }
  };

  // handleItemPress
  const handleItemPress = () => {
    if (!accessToken) return toast.warn("Please login first");
    if (cart?.some((e) => e?._id === cardData?._id)) {
      dispatch(removeItemFromCart(cardData));
    } else {
      dispatch(addItemToCart(cardData));
    }
  };
  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <Header />
      <div className={classes.header}>Card Detail</div>
      <Container className={classes?.containerMain}>
        <Row style={{ alignItems: "center", margin: "20px 0" }}>
          {isLoading ? (
            <Col
              md={12}
              style={{
                display: "grid",
                "place-items": "center",
              }}
            >
              <img src={loaderGif} />
            </Col>
          ) : (
            <>
              <Col lg={4} md={12}>
                <div className={classes?.imd_div}>
                  {cardData?.cards?.length > 0 ? (
                    <ReactElasticCarousel
                      breakPoints={carouselSetting}
                      renderPagination={CarouselPagination}
                      className="mt-5"
                    >
                      {cardData?.cards?.map((e, i) => (
                        <div className={classes.cardImg_div} key={i}>
                          <img src={imageUrl(e?.photo)} />
                        </div>
                      ))}
                    </ReactElasticCarousel>
                  ) : (
                    <img src={imageUrl(cardData?.photo)} />
                  )}
                </div>
              </Col>
              <Col lg={8} md={12}>
                <div className={classes.rightMain}>
                  <h3>{cardData?.name}</h3>
                  <p className={classes.cat_main}>
                    <span className="t-t-c">CATEGORY: </span>
                    {cardData?.category?.name}
                  </p>
                  <h4>
                    <ShowMoreShowLessText
                      text={cardData?.description}
                      visibility={200}
                    />
                  </h4>
                  <div className={classes.tag_div_main}>
                    {cardData?.tags?.map((e, i) => {
                      return (
                        <div
                          md={4}
                          key={i}
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            marginRight: "20px",
                          }}
                        >
                          <div className={classes.tag_div}>
                            <div className={classes.tag_b}>
                              <p className="maxLine1 t-t-c"># {e?.name}</p>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  <Button
                    primary={!cart?.some((e) => e?._id === cardData?._id)}
                    customStyle={{ padding: "20px 70px" }}
                    onClick={handleItemPress}
                  >
                    {cart?.some((e) => e?._id === cardData?._id)
                      ? "Remove from Cart"
                      : "Add to Cart"}
                  </Button>

                  <CopyToClipboard
                    text={window.location.href}
                    onCopy={() => toast.success("Copied to clipboard.")}
                  >
                    <Button
                      className={classes.linkBtn}
                      customStyle={{ padding: "20px 70px", marginLeft: "15px" }}
                      primary
                    >
                      Share Link
                    </Button>
                  </CopyToClipboard>
                </div>
              </Col>
            </>
          )}
        </Row>
      </Container>
      <Footer />
    </>
  );
};

export default CardDetailPage;

const carouselSetting = [
  { width: 1, itemsToShow: 1, showArrows: false },
  {
    width: 500,
    itemsToShow: 2,
    itemsToScroll: 2,
    pagination: false,
    showArrows: false,
    itemPadding: [0, 10],
  },
  { width: 850, itemsToShow: 3, showArrows: false, itemPadding: [0, 10] },
];
